export const GET_AUTOSUGGESTION_RESULTS = "GET_AUTOSUGGESTION_RESULTS";
export const GET_AUTOSUGGESTION_RESULTS_SUCCESS =
  "GET_AUTOSUGGESTION_RESULTS_SUCCESS";
export const GET_AUTOSUGGESTION_RESULTS_ERROR =
  "GET_AUTOSUGGESTION_RESULTS_ERROR";
export const CLEAR_AUTOSUGGESTION_RESULTS = "CLEAR_AUTOSUGGESTION_RESULTS";
export const GET_TOOLBARCONFIG_REQUEST_SUCCESS = "GET_TOOLBARCONFIG_REQUEST_SUCCESS";
export const GET_TOOLBARCONFIG_REQUEST_ERROR = "GET_TOOLBARCONFIG_REQUEST_ERROR";
export const GET_TOOLBARCONFIG_REQUEST = "GET_TOOLBARCONFIG_REQUEST";
